// env.js — which Firebase project this bundle talks to, and the URLs that follow
// from it. Pure values, no imports.
//
// Every default is today's production value, so a production build (which sets
// only the six REACT_APP_FIREBASE_* values from the untracked .env) is unchanged.
// The staging build (scripts/staging/build-staging.js) sets the staging project,
// so functions, storage and public links all resolve to staging, never to prod.
//
// Deliberately not window.location.origin: prod is also served on custom domains.

export const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID || 'solushipx';
export const REGION = 'us-central1';
export const FUNCTIONS_BASE_URL = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;

/** URL of an HTTP (onRequest) function in this bundle's project. */
export const functionUrl = (name) => `${FUNCTIONS_BASE_URL}/${name}`;

/** Canonical public origin of the app, used for links shown to users. */
export const PUBLIC_APP_URL = `https://${PROJECT_ID}.web.app`;

// Keeps the historical appspot -> firebasestorage.app correction for prod's .env.
const configuredBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
export const STORAGE_BUCKET = configuredBucket === 'solushipx.appspot.com'
    ? 'solushipx.firebasestorage.app'
    : (configuredBucket || `${PROJECT_ID}.firebasestorage.app`);

/** 'production' unless the staging build says otherwise. */
export const APP_ENV = process.env.REACT_APP_ENV || 'production';
export const IS_STAGING = APP_ENV === 'staging';

/** Moneris Checkout environment ('prod' | 'qa'). */
export const MONERIS_ENV = process.env.REACT_APP_MONERIS_ENV || 'prod';
